export default __webpack_public_path__ + "static/TileMenu_Default-4578292844dde0b0a7a680e151dbb591.png";